<nav *ngIf="role !== 'FAVORITE'" id="sidebar" class="sidebar sidebar-offcanvas">
    <ul class="nav">
        <li class="nav-item" [routerLinkActive]="'active'">
            <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Dashboard"
                data-original-title="Dashboard" routerLink="/dashboard" appIngressHandler
                [handleIngress]="IMENU.DASHBOARD">
                <i class="fa-solid fa-border-all"></i>
                <span class="menu-title">Dashboard</span>
            </a>
        </li>
        <li class="py-2"></li>

        <li class="nav-item" [routerLinkActive]="'active'">
            <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Company"
                data-original-title="Company" routerLink="/company" appIngressHandler [handleIngress]="IMENU.COMPANY">
                <i class="fa-regular fa-building"></i>
                <span class="menu-title">Companies</span>
            </a>
        </li>

        <!-- <li class="nav-item" [routerLinkActive]="'active'">
            <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Service Centers"
                data-original-title="Service Centers" routerLink="/service-centers" appIngressHandler
                [handleIngress]="IMENU.SERVICE_CENTER">
                <i class="fa-solid fa-store"></i>
                <span class="menu-title">Service Centers</span>
            </a>
        </li> -->

        <!-- <li class="nav-item" [routerLinkActive]="'active'">
            <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Employee"
                data-original-title="Employee" routerLink="/employees" appIngressHandler
                [handleIngress]="IMENU.EMPLOYEE">
                <i class="fa-solid fa-user"></i>
                <span class="menu-title">Employees</span>
            </a>
        </li> -->

        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="collapse" href="#ui-basic" aria-expanded="false"
                aria-controls="ui-basic">
                <i class="fa-regular fa-building"></i>
                <span class="menu-title">Masters</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="ui-basic">
                <ul class="nav flex-column sub-menu">

                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="GST"
                            data-original-title="GST" routerLink="/gst" appIngressHandler
                            [handleIngress]="IMENU.VENDOR">
                            <i class="fa-solid fa-percent"></i>
                            <span class="menu-title">GST</span>
                        </a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Vendors"
                            data-original-title="Vendors" routerLink="/vendors" appIngressHandler
                            [handleIngress]="IMENU.VENDOR">
                            <i class="fa-solid fa-users"></i>
                            <span class="menu-title">Vendors</span>
                        </a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Part"
                            data-original-title="Part" routerLink="/parts" appIngressHandler
                            [handleIngress]="IMENU.PART">
                            <i class="fa-solid fa-screwdriver-wrench"></i>
                            <span class="menu-title">Products</span>
                        </a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Category"
                            routerLink="/category" appIngressHandler [handleIngress]="IMENU.CATEGORY">
                            <i class="fa-solid fa-layer-group"></i>
                            <span class="menu-title">Category</span>
                        </a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Company"
                            routerLink="/partcompany" appIngressHandler [handleIngress]="IMENU.PART_COMPANY">
                            <i class="fa-solid fa-building"></i>
                            <span class="menu-title">Brand</span>
                        </a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Customer"
                            routerLink="/customer" appIngressHandler [handleIngress]="IMENU.CUSTOMER">
                            <i class="fa-solid fa-users-rectangle"></i>
                            <span class="menu-title">Customers</span>
                        </a>
                    </li>
                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Voucher"
                            data-original-title="Voucher" routerLink="/voucher" appIngressHandler
                            [handleIngress]="IMENU.VOUCHER">
                            <i class="fa-solid fa-dolly"></i>
                            <span class="menu-title">Voucher</span>
                        </a>
                    </li>
                </ul>
            </div>
        </li>

        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="collapse" href="#sales" aria-expanded="false" aria-controls="sales">
                <i class="fa-solid fa-cart-shopping"></i>
                <span class="menu-title">Sales</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="sales">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="New Sale"
                            data-original-title="Vendors" routerLink="/sale" appIngressHandler
                            [handleIngress]="IMENU.SALE">
                            <i class="fa-solid fa-plus"></i>
                            <span class="menu-title">New</span>
                        </a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="'active'">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Order Summary"
                            data-original-title="Order Summary" routerLink="/order-summary" appIngressHandler
                            [handleIngress]="IMENU.ORDER_SUMMARY">
                            <i class="fa-solid fa-list"></i>
                            <span class="menu-title">Summary</span>
                        </a>
                    </li>
                </ul>
            </div>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="collapse" href="#reports" aria-expanded="false" aria-controls="reports">
                <i class="fa-solid fa-chart-line"></i>
                <span class="menu-title">Report</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="reports">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Sale Report"
                            data-original-title="Reports" routerLink="/report" appIngressHandler
                            [handleIngress]="IMENU.SALE_REPORT">
                            <i class="fa-solid fa-file-invoice-dollar"></i>
                            <span class="menu-title">Sale Report</span>
                        </a>
                    </li>

                    <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                        <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Purchase Report"
                            data-original-title="Purchase Report" routerLink="/report/purchase-report" appIngressHandler
                            [handleIngress]="IMENU.PURCHASE_REPORT">
                            <i class="fa-solid fa-file-contract"></i>
                            <span class="menu-title text-wrap">Purchase Report</span>
                        </a>
                    </li>

                </ul>
            </div>
        </li>
        <!-- @TODO: when job come it needed -->
        <!-- <li class="nav-item" [routerLinkActive]="'active'">
            <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Job" data-original-title="Job"
                routerLink="/order" appIngressHandler [handleIngress]="IMENU.ORDER">
                <i class="fa-solid fa-table-list"></i>
                <span class="menu-title">Jobs</span>
            </a>
        </li> -->

        <li class="nav-item" [routerLinkActive]="'active'">
            <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Job" data-original-title="Job"
                routerLink="/adjustment" appIngressHandler [handleIngress]="IMENU.INVOICE_UPDATE">
                <i class="fa-solid fa-hammer"></i>
                <span class="menu-title">Adjustment</span>
            </a>
        </li>
    </ul>
</nav>
<nav *ngIf="role === 'FAVORITE'" id="sidebar" class="sidebar sidebar-offcanvas">
    <ul class="nav">
        <li class="nav-item" [routerLinkActive]="'active'">
            <a (click)="closeSidebar()" class="nav-link" data-bs-toggle="tooltip" title="Order Summary"
                data-original-title="Order Summary" routerLink="/order-summary" appIngressHandler
                [handleIngress]="IMENU.ORDER_SUMMARY">
                <i class="fa-solid fa-list"></i>
                <span class="menu-title">Summary</span>
            </a>
        </li>
    </ul>
</nav>